/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Add Icon component.
 */
export const SystemAddIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.74463 8.09277V15.5671' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M7.47436 11.8232H0' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M15.8078 10.8629C17.7681 10.8629 19.3572 9.32657 19.3572 7.43144C19.3572 5.53631 17.7681 4 15.8078 4C13.8474 4 12.2583 5.53631 12.2583 7.43144C12.2583 9.32657 13.8474 10.8629 15.8078 10.8629Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M7.96143 18.999C7.96143 15.6853 10.6477 12.999 13.9614 12.999H16.9999C20.3136 12.999 22.9999 15.6853 22.9999 18.999V19.4221C22.9999 19.6983 22.776 19.9221 22.4999 19.9221H8.46143C8.18528 19.9221 7.96143 19.6983 7.96143 19.4221V18.999Z' stroke={iconColor} strokeWidth='1.5' />
    </svg>
  );
};

export default SystemAddIcon;
